export default "__VITE_ASSET__9fb7b814__"